export default `
query getProductShippingCostData($sku:String!) {
  shippingCost(sku: $sku) {
    shipping_info
    free_shipping_price
    label
  }
}`;
